import React, { useRef } from "react";
import Card from "components/card";
import { connect } from "react-redux";
import { NumberFormatter } from "../../../../utils/index";

const FinalPayAnnex = ({recordData}) => {
	const annexPageRef = useRef();

  	return (
		<Card extra={"w-full h-full p-4 bg-white"}>
			<div ref={annexPageRef}  className="pdf-page bg-white w-full h-full py-8 px-10 text-[12px]">
				<h4 className="ml-4 card-title">ANNEX:</h4>

				<ol className="list-[upper-alpha] ml-8">
				{recordData?.other_deductions?.map((item) => (
					<li className="mb-4" key={item.sdd_id}>
						<div className="grid grid-cols-1 mt-1 md:grid-cols-4 gap-0 md:gap-2">
							<div className="md:col-span-4 font-bold">{item.sdd_other_specific ?? item.sdd_paycode_name}</div>
						</div>
						<div className="grid grid-cols-1 mt-1 md:grid-cols-4 gap-0 md:gap-2">
							<div className=""></div> 
							<div className="md:col-span-2 font-bold">
								AMOUNT DUE
							</div>
							<div className="flex flex-col gap-2 px-2">
								<div className="text-right font-bold">{NumberFormatter(item.sdd_total_amount, 2,'-')}</div>
							</div>
						</div>
						<div className="grid grid-cols-1 mt-1 md:grid-cols-4 gap-0 md:gap-2">
							<div className=""></div> 
							<div className="md:col-span-2 font-bold">
								PAYMENTS:
							</div>
							<div className="flex flex-col gap-2 px-2"></div>
						</div>

						{item?.deductionHistory?.map((period) => (
						<div className="grid grid-cols-1 mt-1 md:grid-cols-4 gap-0 md:gap-2">
							<div className=""></div> 
							<div className="">{period.ppd_payroll_cutoff ?? period.payrun?.payroll?.cut_off}</div>
							<div className="flex flex-col gap-2 px-2 text-right">
								{NumberFormatter(period.ppd_amount, 2,'-')}
							</div>
							<div className="flex flex-col gap-2 px-2"></div>
						</div>
						))}
						<div className="grid grid-cols-1 mt-1 md:grid-cols-4 gap-0 md:gap-2">
							<div className=""></div> 
							<div className="md:col-span-2 font-bold">
								TOTAL PAYMENT
							</div>
							<div className="flex flex-col gap-2 px-2">
								<div className="text-right font-bold">{NumberFormatter(item.sdd_total_payment)}</div>
							</div>
						</div>
						<div className="grid grid-cols-1 mt-1 md:grid-cols-4 gap-0 md:gap-2 mt-2 mb-4">
							<div className=""></div> 
							<div className="md:col-span-2 font-bold border-t-2 py-2">
								BALANCE
							</div>
							<div className="flex flex-col gap-2 px-2 border-t-2 py-2">
								<div className="text-right font-bold">{NumberFormatter(item.sdd_total_amount - item.sdd_total_payment)}</div>
							</div>
						</div>
					</li>
				))}
				</ol>
				</div>
		</Card>
  	);
};

const mapStateToProps = (state) => ({
  	recordData: state.finalPay.finalPayDetails?.data,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(FinalPayAnnex);
